module.exports = __webpack_public_path__ + "static/img/missionFeature.b1a0f0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team/missionFeature.jpg
// module id = 57
// module chunks = 0